<template>

     <v-row class="text-center pa-0 " no-gutters>
    <v-col class="mx-0 pa-0 col-12 offset-0">
      <v-card  
        class="brown lighten-4 justify-center align-center text-center"
        to="sos"
        elevation="0"
      >
        <!-- <div 
          class="brown lighten-4"
          min-height="100px"
        ></div> -->
        <v-img
          contain
          aspect-ratio="3.9"
          style="background-image: url(https://firebasestorage.googleapis.com/v0/b/pravo-na-jizn.appspot.com/o/contacts%2FlogoSOS.jpg?alt=media&token=699cba2f-6d2f-4161-be04-8d325cad96fd); background-position: center center; background-size: cover;"
        >
        </v-img>

        <v-card-text  class="py-1 textColor  text-md-h5 text-sm-h5 text-xs-h6 font-weight-bold  text-left textWordBreak"
          data-aos="fade-up"
          data-aos-offset="100"
          data-aos-delay="10"
          data-aos-duration="1000"
          data-aos-easing="ease-out-back"
          data-aos-once="false"
          data-aos-anchor-placement="top-bottom"
        >
        Мы очень нуждаемся в Вашей помощи...
        </v-card-text>

      </v-card>

    </v-col>
  </v-row>

</template>



<script>
export default {
  name: "SectionNeedHelp",
 

};
</script>

